var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngosinvestLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.22057L12.5606 0.53039C12.9745 0.208621 13.4785 0.0241418 14.0022 0.00272259C14.4943 0.00300195 14.9691 0.184535 15.3359 0.51266C15.7026 0.840785 15.9357 1.2925 15.9905 1.78155C16 1.96911 16 2.15703 15.9905 2.34458V11.0701L31.9918 0V22.7794L19.4312 31.4696C19.0174 31.7914 18.5134 31.9759 17.9896 31.9973C17.5664 31.997 17.1541 31.8626 16.812 31.6134C16.4699 31.3642 16.2156 31.0129 16.0857 30.6101C15.9964 30.2789 15.9633 29.935 15.9878 29.5929V24.8085C15.9878 24.7133 15.9878 24.6208 15.9878 24.5365C15.9534 24.1984 15.833 23.8747 15.6381 23.5962C15.4432 23.3178 15.1802 23.0939 14.8743 22.9458C14.5684 22.7978 14.2296 22.7305 13.8904 22.7504C13.5511 22.7703 13.2225 22.8768 12.936 23.0596L12.7374 23.1929L0 32V9.22057Z",
    fill: "url(#paint0_linear_2227_3187)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2227_3187",
    x1: -2.07947,
    y1: 16,
    x2: 29.9848,
    y2: 32.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngosinvestLogoNew);
export default __webpack_public_path__ + "static/media/ingosinvest-logo-new.1d540435b6c3b9cc9c258f87d79280a4.svg";
export { ForwardRef as ReactComponent };